module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/decorations/deco-dots-5-1aac1fa1bae5f798b237977cf90205a1.svg";